import "./Dubai.scss";
import Container from "react-bootstrap/Container";
import Row from "react-bootstrap/Row";
import Col from "react-bootstrap/Col";
import { Link } from "react-router-dom";
import Dubai1 from "../../assets/images/Dubai1.png";
import PDF from "../../assets/pdfs/CleverDomizil_UAE_v2.pdf";
import Video from "../../assets/videos/CleverDomizil_UAE_v3.mp4";
import { Tag } from "../../utils/GTMPageTag";
import { Image } from "react-bootstrap";

import { useTranslation } from "react-i18next";

const Dubai = () => {
  Tag("Dubai")
  const { t } = useTranslation(["common","dubai"]);

  return (
    <div className="MainbBody UAE">
      <div className="PricelistBanner MapBanner">
        <Container>
          <Row>
            <Col sm={8}>
              <div>
                <h3>{t('dubai:title')}</h3>
                <p>{t('dubai:subtitle')}</p>
              </div>
            </Col>
          </Row>
        </Container>
      </div>
      <div className="PricelistBody">
        <Container>
          <div className="LocationGrid">
            <Row>
              <Col sm={12} md={6}>
                <div className="image">
                  <Image src={Dubai1} alt="Dubai city"/>
                </div>
              </Col>
              <Col sm={12} md={6}>
                <div className="description">
                  <h3>{t('dubai:text_0.title')}</h3>
                  <p>{t('dubai:text_0.description')}</p>
                  <ul>
                    {Array.isArray(t('dubai:text_0.list', {returnObjects: true})) ?
                      t('dubai:text_0.list', { returnObjects: true }).map(item => (
                        <li key={item}>{item}</li>
                      ))
                    : null}
                  </ul>
                </div>
              </Col>
            </Row>
          </div>

          <div className="LocationGrid">
            <Row>
              <Col sm={12}>
                <div className={"description"}>
                  <h3>{t('dubai:text_1.title')}</h3>
                  <p>{t('dubai:text_1.description')}</p>
                  <p>
                    <b>{t('dubai:text_1.description_1.title')}</b>
                    <br/>
                    {t('dubai:text_1.description_1.description')}
                  </p>
                  <p>
                    <b>{t('dubai:text_1.description_2.title')}</b>
                    <br/>
                    {t('dubai:text_1.description_2.description')}
                  </p>
                  <p>
                    <b>{t('dubai:text_1.description_3.title')}</b>
                    <br/>
                    {t('dubai:text_1.description_3.description')}
                  </p>
                  <ul style={{listStyle:"number"}}>
                    {Array.isArray(t('dubai:text_1.list', {returnObjects: true})) ?
                      t('dubai:text_1.list', { returnObjects: true }).map(item => (
                        <li key={item}>{item}</li>
                      ))
                    : null}
                  </ul>
                </div>
              </Col>
            </Row>
          </div>

          <div className="LocationGrid">
            <Row>
              <Col sm={12} md={6}>
                <div className="description">
                  <h3>{t('dubai:text_2.title')}</h3>
                  <p>{t('dubai:text_2.description')}</p>
                  <p>
                    {t('dubai:text_2.mail')}<br/>
                    {t('dubai:text_2.mobile')}<br/>
                    {t('dubai:text_2.phone')}
                  </p>

                  <p>
                    {t('dubai:text_2.contact')}<br/>
                    {t('dubai:text_2.contact_address')}<br/>
                    {t('dubai:text_2.contact_phone')}<br/>
                    {t('dubai:text_2.contact_mail')}
                  </p>

                  <div
                    style={{
                      display: "flex",
                      justifyContent: "flex-start",
                      gap: "10px",
                    }}
                  >
                    <Link to={PDF} target={"_blank"}>
                      {t('dubai:button_0')}
                    </Link>
                    <Link to="https://www.canva.com/design/DAGqof5ZaVc/hIU4RWjS-7QH0__ZmbHt_w/edit?utm_content=DAGqof5ZaVc&utm_campaign=designshare&utm_medium=link2&utm_source=sharebutton">
                      {t('dubai:button_1')}
                    </Link>
                    <Link to="/kontakt">
                      {t('dubai:button_2')}
                    </Link>
                  </div>
                </div>
              </Col>
              <Col sm={12} md={6}>
                <div className="image" style={{ backgroundColor: "#f4f4f4" }}>
                  <video className={"w-100 h-100"} controls>
                    <source src={Video} type="video/mp4" />
                    Your browser does not support the video tag.
                  </video>
                </div>
              </Col>
            </Row>
          </div>
        </Container>
      </div>
    </div>
  );
};

export default Dubai;
